import { useCallback } from 'react';
import { GridMultiSelect } from './GridMultiSelect';

import type { Dispatch, SetStateAction } from 'react';

export type SearchSelectOption = {
    id: string;
    name: string;
};

type GridSearchSelectProps<T extends Record<any, any>> = {
    idKey?: keyof T;
    state: T;
    size?: number;
    options: SearchSelectOption[];
    getLabel: (id: string) => string;
    dispatch: Dispatch<SetStateAction<T>>;
    label: string;
    disabled?: boolean;
};

export const GridSearchSelect = <State extends Record<any, any>>({
    size = 12,
    options,
    state,
    label,
    idKey,
    getLabel,
    dispatch,
    disabled = false,
}: GridSearchSelectProps<State>) => {
    const dispatcher = useCallback((_: SearchSelectOption[], data: SearchSelectOption[]) => {
        dispatch((prev) => {
            const { id } = data.pop() ?? {};

            return {
                ...prev,
                ...(idKey ? { [idKey]: id ? +id : null } : undefined),
            };
        });
    }, []);

    const selected: { id: string; name: string }[] = (idKey ? !state?.[idKey] : !getLabel(state[idKey] as string))
        ? []
        : [
              {
                  id: idKey ? state?.[idKey]?.toString() : getLabel(state?.[idKey] as string),
                  name: getLabel(state?.[idKey] as string),
              },
          ];

    return (
        <GridMultiSelect
            disable={disabled}
            includeAll={false}
            size={size}
            label={label}
            options={options}
            state={selected}
            dispatch={dispatcher}
        />
    );
};
